import {AdminViewer} from "../../components";
export default AdminViewer;